var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShipping({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#132E47"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3864 10.8632C23.7378 11.2147 23.7378 11.7845 23.3864 12.136L14.3864 21.136C14.0349 21.4875 13.4651 21.4875 13.1136 21.136L8.61358 16.636C8.26211 16.2845 8.26211 15.7147 8.61358 15.3632C8.96505 15.0117 9.5349 15.0117 9.88637 15.3632L13.75 19.2268L22.1136 10.8632C22.465 10.5117 23.0349 10.5117 23.3864 10.8632Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipping);
export default __webpack_public_path__ + "static/media/shipping.c580017d5716f479f0d68dabc377e224.svg";
export { ForwardRef as ReactComponent };